"use strict";

class RtGlobalSettingsController {
  constructor(openFinApi, globalSettingsRepository, windowTitle) {
    windowTitle.set("New REDI Window Settings");
    this.openFinApi = openFinApi;
    this.globalSettingsRepository = globalSettingsRepository;
    this.globalSettingsRepository.get().then(globalSettings => {
      this.globalSettings = globalSettings;
    });
  }

  isSavable() {
    return this.globalSettings;
  }

  close() {
    if (this.openFinApi.isInOpenFin) {
      this.openFinApi.getFin().then(fin => {
        const force = false;
        fin.desktop.Window.getCurrent().close(force);
      });
    } else {
      window.document.body.innerHTML =
        "Windows cannot be closed in browsers other than OpenFin - please close this window manually.";
    }
  }

  save(globalSettings) {
    this.globalSettingsRepository.save(globalSettings).then(() => {
      this.openFinApi.publish("global-settings-changed", globalSettings);
      this.close();
    });
  }
}

module.exports = /*@ngInject*/ RtGlobalSettingsController;



// WEBPACK FOOTER //
// ./app/presentation/controllers/RtGlobalSettingsController.js